import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=f56d9ba2&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports